// tslint:disable: no-string-literal

import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'kt-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit {
  @Input() customCls = '';
  @Input() url = '';
  @Input() routerLink = '';
  @Input() badgeCnt = 0;
  @Input() icon = '';
  @Input() iconType = '';
  @Input() width = 28;
  @Input() height = 28;
  @Input() alt = '';

  get cnt() {
    return this.badgeCnt > 9 ? '9+' : this.badgeCnt;
  }

  get svgStyle() {
    const style = {
      'width.px': this.width,
      'height.px': this.height,
    };

    if (this.badgeCnt > 0) {
      style['fill'] = '#1c71b5';
    } else {
      style['fill'] = '#b3b5b8';
    }

    return style;
  }

  get imgStyle() {
    return this.sanitizer.bypassSecurityTrustStyle(`width: ${this.width}px; height: ${this.height}px;`);
  }

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {}
}
